<template>
  <div class="coupon responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'timesheets', label: 'Time Sheets' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "timeSheets",
  data() {
    return {
      listPageHeader,
      entity: Entities.TIMESHEET,
    };
  },
  mounted: function () {
    this.setPageTitle("Time Sheets");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "timeSheetModule/sort",
      pagination: "timeSheetModule/pagination",
      initialFilter: "timeSheetModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "timeSheetModule/updateSort",
      updatePagination: "timeSheetModule/updatePagination",
      updateInitialFilter: "timeSheetModule/updateInitialFilter"
    }),
  }
};
</script>
